import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { R as d, T as v, P as x, C as y } from "../index-D4JPp1jr.js";
import { R as C } from "../index-B_nZygZa.js";
import { c as P } from "../index-Cu0xwYjD.js";
import l from "react";
const b = "_content_4ywgb_1", g = "_scaleIn_4ywgb_1", h = "_item_4ywgb_12", w = "_active_4ywgb_26", R = "_separator_4ywgb_36", s = {
  content: b,
  scaleIn: g,
  item: h,
  active: w,
  separator: R
}, m = l.createContext({
  close: () => {
  }
}), S = ({
  trigger: a,
  children: r,
  onOpenChange: t,
  defaultOpen: c = !1,
  align: n = "end",
  container: _
}) => {
  const [u, p] = l.useState(c), i = (o) => {
    p(o), t == null || t(o);
  };
  return /* @__PURE__ */ f(d, { open: u, onOpenChange: i, children: [
    /* @__PURE__ */ e(v, { asChild: !0, children: a }),
    /* @__PURE__ */ e(x, { container: _, children: /* @__PURE__ */ e(
      y,
      {
        className: s.content,
        sideOffset: 5,
        align: n,
        onOpenAutoFocus: (o) => o.preventDefault(),
        children: /* @__PURE__ */ e(
          m.Provider,
          {
            value: { close: () => i(!1) },
            children: r
          }
        )
      }
    ) })
  ] });
}, T = ({
  children: a,
  closeMenuOnClick: r = !1,
  active: t = !1
}) => {
  const { close: c } = l.useContext(m), n = () => {
    r && c();
  };
  return /* @__PURE__ */ e(
    "div",
    {
      className: P(s.item, t && s.active),
      onClick: n,
      children: a
    }
  );
}, A = () => /* @__PURE__ */ e(C, { className: s.separator, decorative: !0 });
export {
  S as PopoverMenu,
  T as PopoverMenuItem,
  A as PopoverMenuSeparator
};
